/*
  WHIFF V2 | PDP adapter (vaiheet 3-7A)

  PERIAATE: Kingin valitsin (variants-set) on AINOA varianttitotuuden lahde.
  Taman tiedoston painikkeet eivat koskaan pida omaa valintaa. Ne:
  1. valitsevat saman vaihtoehdon Kingin valitsimesta option value ID:n perusteella
     ja laukaisevat saman change-tapahtuman kuin tavallinen klikkaus, ja
  2. lukevat oman tilansa aina Kingista (sync):
     - valittu koko      = Kingin valitsimen valittu vaihtoehto
     - hinta             = Kingin oma hintaelementti (kopioidaan sellaisenaan)
     - saatavuus/teksti  = Kingin oma Add to cart -painike
     Sync ajetaan aina, kun Kingin valitsin, lomakkeen variant ID, hinta tai painike muuttuu,
     riippumatta siita, mista muutos tuli. Ostolaatikko, sticky ja alapaneeli eivat voi
     ajautua eri varianttiin.

  Kaikki muu on King 2.0.4:n omaa logiikkaa (assets/theme.js, ei muutettu):
  variant ID, hinta, saatavuus, media, ?variant= URL, lomakkeet, ostoskori.

  Muut tehtavat:
  - Find your size: "Choose" valitsee koon ostolaatikosta ja vierittaa sinne
  - Tuotekortit (If you like): sama kokopainikelogiikka kortin omaan Kingin valitsimeen
  - Sticky Add to Bag: nakyvyys, alapaneeli (mobiili), lomakkeen lahetys Kingin lomakkeella
  - The Scent: Read more / Show less (ilman JavaScriptia koko teksti nakyy)
  - Vaihe 5B: toimitus- ja etulaatikko (toimitusarvio, maavalinta, ilmainen toimitus / 2 ml -palkki),
    kuvalaskuri "1 / 2" ja "Discover the scent" -linkki.
    Palkin summa luetaan ostoskorista (/cart.js), kun Kingin cart-update -tapahtuma tulee.
    Rajat ja lahetyssaanto: snippets/whiff-offers-config.liquid.
    Vaihe 7A: toimitus- ja etulaatikon laskenta on assets/whiff-core.js:ssa (yhteinen ostoskorin kanssa).
*/
(function () {
  if (window.WhiffPdpAdapter) return;
  window.WhiffPdpAdapter = true;

  var sections = {};

  /* ---------- Kingin elementit ---------- */

  function kingInfo(sectionId) {
    return document.getElementById('main--product-info-' + sectionId);
  }
  function kingPicker(sectionId) {
    var info = kingInfo(sectionId);
    return info ? info.querySelector('variants-set') : null;
  }
  function productId(sectionId) {
    var buybox = document.querySelector('[data-whiff-buybox][data-section="' + sectionId + '"]');
    if (buybox && buybox.dataset.product) return buybox.dataset.product;
    var picker = kingPicker(sectionId);
    return picker ? picker.dataset.product : '';
  }
  function kingForm(sectionId) {
    return document.getElementById('main-product-form-' + sectionId + '-' + productId(sectionId));
  }
  function kingAddButton(sectionId) {
    return document.getElementById('product--submit-btn-' + sectionId + '-' + productId(sectionId));
  }
  function kingPriceWrapper(sectionId) {
    return document.getElementById('price--wrapper-' + sectionId);
  }

  /* Valittu vaihtoehto Kingin valitsimesta (totuus) */
  function kingSelectedValueId(sectionId) {
    var picker = kingPicker(sectionId);
    if (!picker) return '';
    var input = picker.querySelector('optionset input:checked');
    if (input) return input.dataset.optionValueId || '';
    var select = picker.querySelector('select');
    if (select && select.selectedOptions && select.selectedOptions[0]) {
      return select.selectedOptions[0].dataset.optionValueId || '';
    }
    return '';
  }

  /* Kingin valitsimen vaihtoehdon valinta: sama kuin kayttajan klikkaus Kingin painikkeeseen */
  function selectInKing(picker, valueId) {
    var input = picker.querySelector('optionset input[data-option-value-id="' + valueId + '"]');
    if (input) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    var select = picker.querySelector('select');
    if (select) {
      var option = select.querySelector('option[data-option-value-id="' + valueId + '"]');
      if (!option) return false;
      select.value = option.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    return false;
  }

  /* ---------- Sync: kaikki WHIFF-elementit Kingin tilasta ---------- */

  function syncSection(sectionId) {
    var valueId = kingSelectedValueId(sectionId);
    var chosen = null;

    document.querySelectorAll('[data-whiff-size][data-whiff-section="' + sectionId + '"]').forEach(function (button) {
      var on = !!valueId && button.dataset.optionValueId === valueId;
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on && !chosen) chosen = button;
    });

    if (chosen) {
      var selected = document.querySelector('[data-whiff-selected="' + sectionId + '"]');
      if (selected) selected.textContent = chosen.dataset.label;

      var hint = document.querySelector('[data-whiff-hint="' + sectionId + '"]');
      if (hint) {
        hint.textContent = chosen.dataset.hint || '';
        hint.hidden = !chosen.dataset.hint;
      }

      document.querySelectorAll('[data-whiff-sticky-size="' + sectionId + '"]').forEach(function (el) {
        el.textContent = chosen.dataset.label;
      });
      syncSizeGuide(valueId);
    }

    /* Hinta: kopio Kingin omasta hintaelementista */
    var wrapper = kingPriceWrapper(sectionId);
    var actual = wrapper ? wrapper.querySelector('.product--actual-price') : null;
    if (actual) {
      var cut = wrapper.querySelector('.product--cut-price');
      var html = '<span class="whiff-sticky__price-now">' + actual.innerHTML + '</span>';
      if (cut) html += ' <span class="whiff-sticky__price-was">' + cut.innerHTML + '</span>';
      document.querySelectorAll('[data-whiff-sticky-price="' + sectionId + '"]').forEach(function (el) {
        if (el.innerHTML !== html) el.innerHTML = html;
      });
    }

    /* Saatavuus ja teksti: Kingin oma Add to cart -painike */
    var kingButton = kingAddButton(sectionId);
    var add = document.querySelector('[data-whiff-sticky-add="' + sectionId + '"]');
    if (kingButton && add) {
      var disabled = kingButton.disabled || kingButton.hasAttribute('disabled');
      add.disabled = disabled;
      add.classList.toggle('is-loading', kingButton.classList.contains('loading'));
      var kingText = kingButton.querySelector('[data-atc-text]');
      var label = add.querySelector('[data-whiff-sticky-add-label]');
      var shortLabel = add.querySelector('.whiff-sticky__add-short');
      if (kingText && label) {
        var text = kingText.textContent.trim();
        if (text && label.textContent !== text) label.textContent = text;
        if (shortLabel) {
          if (disabled) {
            shortLabel.textContent = text;
          } else if (shortLabel.dataset.short) {
            shortLabel.textContent = shortLabel.dataset.short;
          }
        }
      }
    }
  }

  function scheduleSync(sectionId) {
    var state = sections[sectionId];
    if (!state || state.pending) return;
    state.pending = true;
    window.requestAnimationFrame(function () {
      state.pending = false;
      syncSection(sectionId);
    });
  }

  function syncSizeGuide(valueId) {
    document.querySelectorAll('[data-whiff-pick]').forEach(function (pick) {
      if (pick.disabled) return;
      var on = pick.dataset.whiffPick === valueId;
      pick.setAttribute('aria-pressed', on ? 'true' : 'false');
      pick.textContent = on ? pick.dataset.labelSelected : pick.dataset.labelChoose;
      var card = pick.closest('.whiff-sizecard');
      if (card) card.classList.toggle('is-selected', on);
    });
  }

  /* Kuuntelijat: mika tahansa muutos Kingin valitsimessa, hinnassa tai painikkeessa */
  function observeKing(sectionId) {
    var state = sections[sectionId];
    if (state.observers) state.observers.forEach(function (o) { o.disconnect(); });
    state.observers = [];
    var run = function () { scheduleSync(sectionId); };
    [
      [kingPicker(sectionId), { childList: true, subtree: true }],
      [kingPriceWrapper(sectionId), { childList: true, subtree: true, characterData: true }],
      [kingAddButton(sectionId), { attributes: true, childList: true, subtree: true, characterData: true }]
    ].forEach(function (pair) {
      if (!pair[0] || !window.MutationObserver) return;
      var observer = new MutationObserver(run);
      observer.observe(pair[0], pair[1]);
      state.observers.push(observer);
    });
  }

  /* ---------- Sticky Add to Bag ---------- */

  function setStickyVisible(state, visible) {
    var sticky = state.sticky;
    if (!sticky || state.visible === visible) return;
    state.visible = visible;
    sticky.classList.toggle('is-visible', visible);
    sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
    if ('inert' in sticky) sticky.inert = !visible;
    document.documentElement.classList.toggle('whiff-sticky-on', visible);
    if (!visible) closeSheet(state.id, false);
  }

  function initSticky(sectionId) {
    var state = sections[sectionId];
    var sticky = document.querySelector('[data-whiff-sticky="' + sectionId + '"]');
    var sheet = document.querySelector('[data-whiff-sheet="' + sectionId + '"]');
    if (!sticky) return;

    /* Siirto bodyyn: position: fixed toimii varmasti riippumatta teeman rakenteesta.
       Theme Editorin uudelleenlatauksessa vanha kopio poistetaan ensin. */
    [sticky, sheet].forEach(function (el) {
      if (!el) return;
      document.querySelectorAll('body > #' + el.id).forEach(function (old) {
        if (old !== el) old.remove();
      });
      if (el.parentNode !== document.body) document.body.appendChild(el);
    });

    state.sticky = sticky;
    state.sheet = sheet;
    state.visible = null;
    sticky.hidden = false;
    setStickyVisible(state, false);

    var shortLabel = sticky.querySelector('.whiff-sticky__add-short');
    if (shortLabel && !shortLabel.dataset.short) shortLabel.dataset.short = shortLabel.textContent.trim();

    var target = document.getElementById('product--buy-buttons-' + sectionId) || kingAddButton(sectionId);
    var footer = document.querySelector('footer, .shopify-section-group-footer-group');
    if (!target || !('IntersectionObserver' in window)) return;

    state.pastAtc = false;
    state.footerVisible = false;
    var update = function () { setStickyVisible(state, state.pastAtc && !state.footerVisible); };

    if (state.io) state.io.forEach(function (o) { o.disconnect(); });
    state.io = [];
    var atcObserver = new IntersectionObserver(function (entries) {
      var entry = entries[entries.length - 1];
      state.pastAtc = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      update();
    });
    atcObserver.observe(target);
    state.io.push(atcObserver);

    if (footer) {
      var footerObserver = new IntersectionObserver(function (entries) {
        state.footerVisible = entries[entries.length - 1].isIntersecting;
        update();
      });
      footerObserver.observe(footer);
      state.io.push(footerObserver);
    }
  }

  /* Alapaneeli (mobiilin kokovalitsin) */
  function openSheet(sectionId, trigger) {
    var state = sections[sectionId];
    if (!state || !state.sheet) return;
    state.sheetTrigger = trigger || null;
    state.sheet.hidden = false;
    document.documentElement.classList.add('whiff-sheet-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    window.requestAnimationFrame(function () {
      state.sheet.classList.add('is-open');
      var first = state.sheet.querySelector('[data-whiff-size][aria-pressed="true"]') ||
        state.sheet.querySelector('[data-whiff-size]:not([aria-disabled="true"])') ||
        state.sheet.querySelector('.whiff-sheet__close');
      if (first) first.focus();
    });
  }

  function closeSheet(sectionId, restoreFocus) {
    var state = sections[sectionId];
    if (!state || !state.sheet || state.sheet.hidden) return;
    state.sheet.classList.remove('is-open');
    state.sheet.hidden = true;
    document.documentElement.classList.remove('whiff-sheet-open');
    var trigger = state.sheetTrigger || document.querySelector('[data-whiff-sheet-open="' + sectionId + '"]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (restoreFocus !== false && trigger) trigger.focus();
  }

  function openSheetId() {
    for (var id in sections) {
      if (sections[id].sheet && !sections[id].sheet.hidden) return id;
    }
    return '';
  }

  /* ---------- Kokopainikkeet ---------- */

  function onSizeClick(button) {
    if (button.getAttribute('aria-disabled') === 'true') return;

    var card = button.closest('[data-whiff-card]');
    if (card) {
      if (button.getAttribute('aria-pressed') === 'true') return;
      var cardPicker = card.querySelector('variants-set');
      if (!cardPicker || !selectInKing(cardPicker, button.dataset.optionValueId)) return;
      card.querySelectorAll('[data-whiff-size]').forEach(function (item) {
        item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
      });
      return;
    }

    var sectionId = button.dataset.whiffSection;
    if (!sectionId) return;
    var picker = kingPicker(sectionId);
    if (!picker) return;
    if (button.getAttribute('aria-pressed') !== 'true') {
      if (!selectInKing(picker, button.dataset.optionValueId)) return;
    }
    syncSection(sectionId);

    if (button.closest('[data-whiff-sheet]')) {
      window.setTimeout(function () { closeSheet(sectionId); }, 180);
    }
  }

  function onPickClick(pick) {
    if (pick.disabled) return;
    var valueId = pick.dataset.whiffPick;
    var target = document.querySelector('[data-whiff-buybox] [data-whiff-size][data-option-value-id="' + valueId + '"]');
    if (!target) return;
    onSizeClick(target);
    var buybox = target.closest('[data-whiff-buybox]');
    if (buybox) {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      buybox.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      target.focus({ preventScroll: true });
    }
  }

  /* ---------- The Scent: Read more ---------- */

  /* Lyhennetty tila nayttaa noin 4 rivia. Painike tulee, jos tekstia on yli noin 5 rivia.
     Rivikorkeus mitataan tekstin omasta kappaleesta (teeman fonttikoko huomioiden). */
  function measureReadMore(text) {
    var toggle = document.querySelector('[data-whiff-readmore-toggle][aria-controls="' + text.id + '"]');
    if (!toggle || text.classList.contains('is-open')) return;
    var sample = text.querySelector('p') || text;
    var lineHeight = parseFloat(window.getComputedStyle(sample).lineHeight) || 28;
    text.style.setProperty('--whiff-collapsed-height', Math.round(lineHeight * 4) + 'px');
    text.classList.remove('is-collapsible');
    var needed = text.scrollHeight > lineHeight * 5.5;
    text.classList.toggle('is-collapsible', needed);
    toggle.hidden = !needed;
  }

  function initReadMore(scope) {
    (scope || document).querySelectorAll('[data-whiff-readmore]').forEach(measureReadMore);
  }

  function onReadMoreClick(toggle) {
    var text = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!text) return;
    var open = !text.classList.contains('is-open');
    text.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.textContent = open ? toggle.dataset.labelLess : toggle.dataset.labelMore;
    if (!open) {
      var rect = text.getBoundingClientRect();
      if (rect.top < 0) text.scrollIntoView({ block: 'start' });
    }
  }


  /* ---------- Vaihe 5B: toimitus- ja etulaatikko ----------
     Vaihe 7A: laskenta on siirretty tiedostoon assets/whiff-core.js (yhteinen tuotesivulle ja
     ostoskorille). Tama tiedosto vain kaynnistaa sen alla init()-funktiossa. */
  function initDelivery(scope) {
    if (window.WhiffCore && window.WhiffCore.initDelivery) window.WhiffCore.initDelivery(scope);
  }

  /* ---------- Vaihe 5B: kuvalaskuri ja Discover the scent ---------- */

  function initMedia(buybox) {
    var section = buybox.closest('.shopify-section') || document;
    var gallery = section.querySelector('media-gallery');
    if (!gallery || gallery.querySelector('.whiff-media-counter')) return;
    var indexes = [];
    gallery.querySelectorAll('.main--product-item').forEach(function (slide) {
      var index = slide.getAttribute('data-swiper-slide-index') || slide.dataset.mediaId;
      if (indexes.indexOf(index) === -1) indexes.push(index);
    });
    if (indexes.length < 2) return;

    var counter = document.createElement('div');
    counter.className = 'whiff-media-counter';
    counter.setAttribute('aria-hidden', 'true');
    counter.innerHTML = '<span data-current>1</span> / ' + indexes.length;
    (gallery.querySelector('.main--product-media') || gallery).appendChild(counter);

    var tries = 0;
    (function attach() {
      var swiper = gallery.sliderImages;
      if (swiper && typeof swiper.on === 'function') {
        var update = function () {
          var current = (typeof swiper.realIndex === 'number' ? swiper.realIndex : swiper.activeIndex) + 1;
          counter.querySelector('[data-current]').textContent = current;
        };
        swiper.on('slideChange', update);
        update();
      } else if (tries < 20) {
        tries += 1;
        window.setTimeout(attach, 250);
      }
    })();
  }

  function initDiscover(scope) {
    var target = document.getElementById('whiff-scent');
    (scope || document).querySelectorAll('[data-whiff-discover]').forEach(function (link) {
      link.hidden = !target;
    });
  }

  /* Maavalinta: assets/whiff-core.js */

  /* ---------- Kaynnistys ---------- */

  function initSection(buybox) {
    var sectionId = buybox.dataset.section;
    if (!sectionId) return;
    sections[sectionId] = sections[sectionId] || { id: sectionId };

    var picker = kingPicker(sectionId);
    if (picker && picker.dataset.page && picker.dataset.page.indexOf('product.') === 0) {
      picker.dataset.page = 'product';
    }

    observeKing(sectionId);
    initSticky(sectionId);
    syncSection(sectionId);
  }

  function safely(fn) {
    try {
      fn();
    } catch (error) {
      if (window.console) console.warn('WHIFF adapter:', error);
    }
  }

  function init(scope) {
    safely(function () { initReadMore(scope); });
    safely(function () { initDelivery(scope); });
    safely(function () { initDiscover(scope); });
    (scope || document).querySelectorAll('[data-whiff-buybox]').forEach(function (buybox) {
      safely(function () { initSection(buybox); });
      safely(function () { initMedia(buybox); });
    });
  }

  /* Fontit ja kuvat voivat muuttaa tekstin korkeutta: mitataan uudelleen */
  window.addEventListener('load', function () { initReadMore(); });
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () { initReadMore(); }, 200);
  });

  document.addEventListener('click', function (event) {
    var size = event.target.closest('[data-whiff-size]');
    if (size) {
      onSizeClick(size);
      return;
    }
    var pick = event.target.closest('[data-whiff-pick]');
    if (pick) {
      onPickClick(pick);
      return;
    }
    var open = event.target.closest('[data-whiff-sheet-open]');
    if (open) {
      openSheet(open.dataset.whiffSheetOpen, open);
      return;
    }
    var close = event.target.closest('[data-whiff-sheet-close]');
    if (close) {
      var sheet = close.closest('[data-whiff-sheet]');
      if (sheet) closeSheet(sheet.dataset.whiffSheet);
      return;
    }
    var more = event.target.closest('[data-whiff-readmore-toggle]');
    if (more) onReadMoreClick(more);
  });

  /* Muutos Kingin valitsimessa tai lomakkeen variant ID:ssa mista tahansa -> sync */
  document.addEventListener('change', function (event) {
    var target = event.target;
    for (var id in sections) {
      var picker = kingPicker(id);
      var form = kingForm(id);
      if ((picker && picker.contains(target)) || (form && form.contains(target))) {
        scheduleSync(id);
      }
    }
  });

  /* Alapaneelin nappaimisto: Esc sulkee, Tab pysyy paneelissa */
  document.addEventListener('keydown', function (event) {
    var id = openSheetId();
    if (!id) return;
    var sheet = sections[id].sheet;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeSheet(id);
      return;
    }
    if (event.key !== 'Tab') return;
    var focusable = Array.prototype.filter.call(
      sheet.querySelectorAll('.whiff-sheet__panel button:not([disabled])'),
      function (el) { return el.offsetParent !== null; }
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-whiff-buybox]').forEach(function (buybox) {
      var id = buybox.dataset.section;
      ['WhiffSticky-' + id, 'WhiffSheet-' + id].forEach(function (elId) {
        var el = document.getElementById(elId);
        if (el && el.parentNode === document.body) el.remove();
      });
      document.documentElement.classList.remove('whiff-sticky-on', 'whiff-sheet-open');
      delete sections[id];
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
})();

